/**
 * Component: Checkout add-on script
 * ------------------------------------------------------------------------------
 * Loosely coupled scripts for the Cart add-on functionality.
 *
 * @namespace checkoutAddOn
 */
import axios from 'axios';

import cssClasses from '~/helpers/cssClasses';
import {on} from '~/helpers/utils';
import Modal from '~/components/modal';

/**
 * DOM selectors.
 */
const selectors = {
  previewMsg: '[js-cart-add-on="messagePreview"]',
  modalClose: '[js-cart-add-on="closeModal"]',
  preview: '[js-cart-add-on="previewContainer"]',
  description: '[js-cart-add-on="description"]',
  modalMessage: '[js-cart-add-on="previewMessage"]',
  modalImage: '[js-cart-add-on="image"]',
};

/**
 * Instance settings.
 */
const settings = {
  id: 'add-on-modal',
};

/**
 * Create a new cart add-on object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    previewMsg: document.querySelector(selectors.previewMsg),
    modalClose: document.querySelector(selectors.modalClose),
    preview: document.querySelector(selectors.preview),
    description: document.querySelector(selectors.description),
    modalMessage: document.querySelector(selectors.modalMessage),
    modalImage: document.querySelector(selectors.modalImage),
  };

  /**
   * Instance globals.
   */
  const modal = Modal({
    id: settings.id,
  });

  /**
   * Initialise component.
   */
  function init() {
    modal.init();
    checkAddOnProduct();
    setEventListeners();
  }

  /**
   * Set event listeners.
   */
  function setEventListeners() {
    on('click', nodeSelectors.modalClose, () => handleModalCloseEvent());
  }

  function checkAddOnProduct() {
    axios.get(`/cart.js?no-cache=${new Date().getTime()}`)
      .then((response) => {
        const product = response.data.items.find((item) => {
          return item.product_type.toLowerCase() === 'add-on';
        });

        const note = response.data.note || '';

        setPreview(product, note);
      })
      .catch((error) => {
        throw new Error('Could not find ', error);
      });
  }

  function setPreview(product, note) {
    const id = product.product_id;
    let image = theme.images.addOnPreview;
    const previewRow = document.querySelector(`[data-product-id="${id}"]`);

    if (image === '') {
      image = product.image;
    }

    if (note.trim().length <= 0) { return; }

    if (document.querySelector(selectors.previewMsg) !== null) { return; }

    previewRow.querySelector('.product__description__name').innerHTML += `
      <span class="order-summary__small-text">${theme.strings.addOn.checkout}</span>
    `;

    previewRow.querySelector('.product__description__variant').innerHTML += `
      <button
        class="cart-add-on__button-preview button button--primary button--small"
        type="button"
        js-cart-add-on="messagePreview"
      >
        ${theme.strings.addOn.preview}
      </button>
    `;

    const previewBtn = document.querySelector(selectors.previewMsg);
    on('click', previewBtn, (event) => addOnPreview(event));
    nodeSelectors.modalMessage.innerHTML = note;
    nodeSelectors.modalImage.style.backgroundImage = `url(${image})`;
  }

  /**
   * Show add-on message preview.
   * @param {Event} event - click event.
   */
  function addOnPreview(event) {
    event.preventDefault();

    nodeSelectors.description.classList.add(cssClasses.hidden);
    nodeSelectors.preview.classList.remove(cssClasses.hidden);
    handleModalShowEvent();
  }

  /**
   * Handle modal show.
   */
  function handleModalShowEvent() {
    modal.show(settings.id);
  }

  /**
   * Handle modal close.
   */
  function handleModalCloseEvent() {
    modal.close(settings.id);
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
